import {round} from "../utils/money";

export default class NutrientsService {
    parseBasicNutrientPercentageValueToGrams(energy, nutrientId, value) {
        return round(((energy / 100) * +value) / (nutrientId === 2 ? 9 : 4), 0);
    }
    parseBasicNutrientGramsToPercentageValue(energy, nutrientId, value) {
        return round(((nutrientId === 2 ? 9 : 4) * value) / (energy / 100), 0);
    }
}